import { DataEditContextSkillField } from 'Components/reusable/DataContext/fields/DataEditContextSkillField'
import Grid from '@mui/material/Grid2'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IPersonIndustry, ISkillOrIndustryOrRole } from 'types/cvsInterfaces'
import { CvId } from 'types/ids'
import * as Yup from 'yup'
import DataContext, { NewOrExisting } from 'Components/reusable/DataContext'
import LoadingIndicator from 'Components/reusable/LoadingIndicator'
import { TFunction } from 'i18next'

/**
 * YUP schema for industry skills.
 * @notExported
 */
export const skillSchema = (t: TFunction) =>
  Yup.object({
    skillId: Yup.number().required(t('fieldRequired')),
  })

/** @notExported   */
interface IIndustryCreateProps {
  /** CV ID. */
  cvId: CvId
  /** Function to add industry. */
  onAdd: ({ newItem }: { newItem?: NewOrExisting<IPersonIndustry> }) => void
  /** Already added industries. */
  usedIndustries?: ISkillOrIndustryOrRole[]
  /** Whether to inset label. */
  insetLabel?: boolean
}
/**
 * Controls for adding industry to project.
 *
 * @returns Industry create component.
 * @notExported
 */
const IndustryCreate: React.FC<IIndustryCreateProps> = ({ cvId, onAdd, usedIndustries, insetLabel }) => {
  const [data, setData] = useState<NewOrExisting<IPersonIndustry> | null>(null)
  const { t } = useTranslation()

  useEffect(() => {
    setData({
      cvId,
      skillId: null as unknown,
    } as NewOrExisting<IPersonIndustry>)
  }, [onAdd, cvId])

  if (!data) {
    return <LoadingIndicator />
  }

  const add = async () => {
    if (data && data.Skill) onAdd({ newItem: data })
  }

  return (
    <DataContext
      data={data}
      onSubmit={add}
      localeBase="assignment.role.requirement.industry"
      schema={skillSchema(t)}
      onChange={newItem => {
        if (newItem && newItem.Skill) onAdd({ newItem })
      }}
    >
      <Grid container spacing={2}>
        <Grid size={12}>
          <DataEditContextSkillField<IPersonIndustry>
            field="skillId"
            usedSkills={usedIndustries}
            dataField="Skill"
            fullWidth
            type="industry"
            placeholder={t('profile.project.modal.addindustry.placeholder')}
            submitOnEnter={true}
            insetLabel={insetLabel}
          />
        </Grid>
      </Grid>
    </DataContext>
  )
}

export default IndustryCreate
